import { SHOP_PRODUCTS_PATH_A } from '@constant'
import { isUltimate } from '@merchant-backend/util'
import { isSiDaTeam } from '@util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import auth, { FOUR_ROLE } from '../../auth'
import CurrentService from '../Common/CurrentService'
import styles from './style.module.less'

/** 四大商家 */
@auth(FOUR_ROLE)
@observer
export default class extends Component {
  render() {
    const isTeam = isSiDaTeam()

    // 旗舰版商家
    if (isUltimate()) {
      return <CurrentService hideLevelIcon={isTeam} hideSafeShop={!isTeam} />
    }
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>暂未开通商家服务（付费）</div>
        <div className={styles.detail}>
          <span className={styles.text}>
            开通商家服务（付费），独享营销神器，客资转化+经营效率，全面飞跃
          </span>
        </div>
        <a className={styles.btn} href={SHOP_PRODUCTS_PATH_A}>
          立即开通
        </a>
      </div>
    )
  }
}
